<template>
  <div>

    <!--  面包屑  -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>日志管理</el-breadcrumb-item>
      <el-breadcrumb-item>操作日志</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-table :data="logoperationlist" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="登陆名称" prop="lo_mid"></el-table-column>
        <el-table-column label="访问页面" prop="lo_access_id"></el-table-column>
        <el-table-column label="操作记录" prop="lo_record_id"></el-table-column>
        <el-table-column label="当前URL" prop="lo_url"></el-table-column>
        <el-table-column label="操作人IP" prop="lo_ip"></el-table-column>
        <el-table-column label="页面参数" prop="add_date"></el-table-column>

      </el-table>
      <!--分页-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="querInfo.page"
          :page-sizes="[3,5,10,15]"
          :page-size="querInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return{
      logoperationlist:[],
      querInfo: {
        page: 1,
        limit: 10
      },
      //总数据条数
      total: 0,
    }
  },
  created() {
    this.getLogoperationList()
  },
  methods: {
    //获取操作日志
    async getLogoperationList(){
      const {data:res} = await this.$http.get('logoperation/getList',
          {params: this.querInfo})
      if (res.code !== 200) return this.$message.error(res.msg)
      this.logoperationlist=res.data.data
      this.total=res.data.total

    },
    //监听pagesize改变
    handleSizeChange(newSize) {
      this.querInfo.limit = newSize
      this.getLogoperationList()
    },
    //监听pagenum 改变
    handleCurrentChange(newPage) {
      this.querInfo.page = newPage
      this.getLogoperationList()
    },
  }
}
</script>
